<div class="network-partner-container">
  <div *ngIf="!(showConfirm$ | async); else confirmDialogHeader" class="header">
    <a (click)="closeDialog()" class="goback">
      <img alt="go_back" src="./assets/ui/shared/icons/go_back_icon.svg" title="go_back">
      {{ 'network.partner.dialog.back' | translate }}
    </a>
  </div>
  <ng-template #confirmDialogHeader>
    <div class="header">
      <a (click)="closeConfirmDialog()" class="goback">
        <img alt="go_back" src="./assets/ui/shared/icons/go_back_icon.svg" title="go_back">
        {{ 'network.partner.dialog.confirm.back' | translate }}
      </a>
    </div>
  </ng-template>
  <div *ngIf="!(showConfirm$ | async); else confirmDialog" class="content-container">
    <div class="content">
      <div class="title">{{ 'network.partner.dialog.title' | translate }}</div>
      <div class="network-partner-description">{{ 'network.partner.dialog.description' | translate }}</div>
      <div class="network-partner-dropdown-label">{{ 'network.partner.dialog.dropdown.title' | translate }}</div>
      <div class="network-partner-dropdown-row">
        <div #dropDownElement class="network-partner-dropdown">
          <kion-drop-down
            (selected)="updateSelection($event)"
            [options]="networkPartners$ | async"
            [parent]="dropDownElement"
            [showArrowIcon]="true"
            [showDropDownOnClick]="true"
            [title]="title$ | async"
          ></kion-drop-down>
        </div>
        <kion-button (click)="selectCurrentNetworkPartner()"
                     [disabled]="!(submitButtonActive | async)"
                     [title]="'network.partner.dialog.submit' | translate"
                     class="network-partner-button-submit"
                     mode="primary"
        ></kion-button>
      </div>
      <div class="network-partner-text">{{ 'network.partner.dialog.text' | translate }}</div>
      <hr class="separator"/>
      <div *ngIf="selectedNetworkPartner$ | async as selectedNetworkPartner">
        <div class="imprint-images">
          <kion-brand-logo></kion-brand-logo>
          <img class="imprint-logo" src="{{selectedNetworkPartner.logo?.url}}?height=80">
        </div>
        <kion-markdown [content]="data$ | async" [project]="project"></kion-markdown>
        <div>
          <a [customRouterLink]="termsAndConditionLink$ | async"
             class="terms-and-conditions-link"
             target="_blank"
          >
            {{'network.partner.dialog.link.termsAndConditions' | translate}}
          </a>
        </div>
        <div>
          <a [customRouterLink]="privacyLink$ | async"
             class="terms-and-conditions-link"
             target="_blank"
          >
            {{'network.partner.dialog.link.privacy' | translate}}
          </a>
        </div>
      </div>
    </div>
  </div>

  <ng-template #confirmDialog>
    <div class="network-partner-confirm-container">
      <div class="title">{{ 'network.partner.dialog.confirm.title' | translate }}</div>
      <div>{{'network.partner.dialog.confirm.text' | translate}}</div>
      <kion-button (click)="closeDialog()"
                   [title]="'network.partner.dialog.confirm.ok' | translate"
                   mode="primary"
      ></kion-button>
    </div>
  </ng-template>
</div>


